<div class="header">
  <div class="logo-container">
    <img [src]="logoUrl" alt="Logo" />
  </div>
  <div>
    <div class="title">Petición {{request.auftrNr}} {{request['']}}</div>
  </div>
</div>
